import React, { useEffect } from 'react';
import './styles.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';

const LoadingProgress = () => {
    const { SearchPrice } = useSelector((state: RootState) => state.search);

    useEffect(() => {
        const progress = document.querySelector('.progress') as HTMLElement;
        const progressInner = document.querySelector(".progress-bar__inner") as HTMLElement;
        if (!SearchPrice.isLoading) {
            progressInner.classList.add("complete")
            progressInner.classList.remove("progress-animation")
            setTimeout(() => {
                progress.classList.add("hide")
            }, 1000)
        } else {
            progress.classList.remove("hide")
            progressInner.classList.add("progress-animation")
            progressInner.classList.remove("complete")
        }
    }, [SearchPrice.isLoading])

    return (
        <div className="progress">
            <div className="progress-bar">
                <div className="progress-bar__inner" />
            </div>
        </div>
    );
};

export default LoadingProgress;
